import React, { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  Modal,
  Image
} from '@lockerpm/design';

import {
  ArrowRightOutlined
} from "@ant-design/icons";

import dayjs from 'dayjs';

import itemsComponents from "../../../../../components/items";

import GetCodeSuccessIcon from '../../../../../assets/images/icons/get-code-success.svg'

const GetCodeSuccessModal = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation();
  const {
    visible = false,
    currentCode = {},
    onClose = () => {},
    redeemCode = () => {}
  } = props;

  const currentTime = useMemo(() => {
    return dayjs().add(7, 'days').format('MMMM Do YYYY')
  }, [visible])

  return (
    <Modal
      title={<></>}
      open={visible}
      width={430}
      footer={false}
      onCancel={() => onClose()}
    >
      <div className="flex items-center justify-center">
        <Image
          src={GetCodeSuccessIcon}
          preview={false}
        />
      </div>
      <div className="flex justify-center">
        <div
          className="text-black-600 font-semibold"
          style={{
            width: 'max-content',
            padding: '8px 24px',
            border: '1px solid #072245',
            borderRadius: 4
          }}
        >
          <TextCopy
            className="font-bold"
            value={currentCode.code}
          />
        </div>
      </div>
      <div className="text-center mt-3">
        <div className="mb-4">
          {t('rewards.get_code.popup.note1', { time: currentTime })}:
        </div>
        <Trans
          i18nKey={'rewards.get_code.popup.redeem_note'}
          values={{
            time: currentTime,
          }}
          components={{
            b: <b/>
          }}
        />
        <div
          className="mt-5 flex items-center text-primary font-semibold cursor-pointer justify-center"
          onClick={() => redeemCode(currentCode.code)}
        >
          {t('rewards.get_code.redeem_code')}
          <ArrowRightOutlined className="ml-2"/>
        </div>
      </div>
    </Modal>
  );
}

export default GetCodeSuccessModal;